const getLocalStorageIfAvailable = (name) => {
  if (typeof window !== `undefined` && !!localStorage.getItem(name)) {
    return localStorage.getItem(name)
  }
  return null
}

const getSectionIfAvailable = () => {
  if (typeof window !== `undefined`) {
    const params = new URLSearchParams(window.location.search)
    const agePreset = params.get("age")
    if (agePreset) {
      return "basics"
    }
    // Check URL pathname first, before falling back to localStorage
    const urlSection = window.location.pathname.split('/').filter(Boolean).pop()
    if (
      urlSection &&
      urlSection !== "" &&
      urlSection !== "results" &&
      urlSection !== "save-results"
    ) {
      // Normalize "basics" to "basics" for compatibility
      return urlSection
    }
  }
  const section = getLocalStorageIfAvailable("currentSection") || "intro"
  // Normalize "basics" to "basics" for compatibility with progress bar
  return section === "basics" ? "basics" : section
}

const getTokenIfAvailable = () => {
  if (typeof window !== `undefined`) {
    const params = new URLSearchParams(window.location.search)
    const agePreset = params.get("age")
    if (agePreset) {
      return ""
    }
  }
  return getLocalStorageIfAvailable("userToken") || false
}

const defaultState = {
  quizProgress: getLocalStorageIfAvailable("quizProgress")
    ? parseInt(getLocalStorageIfAvailable("quizProgress"))
    : 0,
  get progressBarProgress() {
    return this.quizProgress || 0
  },
  name: getLocalStorageIfAvailable("userName") || undefined,
  sectionLength: getLocalStorageIfAvailable("sectionLength")
    ? parseInt(getLocalStorageIfAvailable("sectionLength"))
    : 0,
  currentSection: getSectionIfAvailable(),
  gender: getLocalStorageIfAvailable("userGender")
    ? JSON.parse(getLocalStorageIfAvailable("userGender"))
    : "",
  age:
    getLocalStorageIfAvailable("userAge") &&
    !isNaN(parseInt(getLocalStorageIfAvailable("userAge")))
      ? parseInt(getLocalStorageIfAvailable("userAge"))
      : 0,
  interstitial: false,
  token: getTokenIfAvailable(),
  currentGlobalId: "",
  responseComplete: false,
  resultsResponseComplete: false,
  totalQuestions: getLocalStorageIfAvailable("totalQuestions")
    ? parseInt(getLocalStorageIfAvailable("totalQuestions"))
    : 24,
  currentTotalProgress: 1,
  animationPropsIn: "fadeIn .5s ease",
  animationPropsOut: "fadeOut .5s ease-in",
  reverseAnimationPropsIn: "fadeInBackwards .5s ease",
  reverseAnimationPropsOut: "fadeOutBackwards .5s ease",
  movingForward: true,
  globalUnmount: false,
  hideProgressForName: false,
  showNameGreeting: false,
  showBackBtn: false,
  quizMounted: false,
  postPartum: false,
  subscription_id: getLocalStorageIfAvailable("subscription_id") || "",
  customer_id: getLocalStorageIfAvailable("customer_id") || "",
  account_user_name: getLocalStorageIfAvailable("account_user_name") || "",
  email_capture: false,
  isMhmd: getLocalStorageIfAvailable("isMhmd") === "true" || "",
  mhmdState: getLocalStorageIfAvailable("mhmdState") || "",
  mhmdOpted: getLocalStorageIfAvailable("mhmdOpted")
    ? getLocalStorageIfAvailable("mhmdOpted") === "true"
    : true,
  isIntroMode: true,
}

export const progressReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "INCREMENT_PROGRESS":
      return { ...state, quizProgress: action.payload }
    case "DECREMENT_PROGRESS":
      return { ...state, quizProgress: action.payload }
    case "INCREMENT_MIRROR_PROGRESS":
      return { ...state, progressBarProgress: action.payload }
    case "DECREMENT_MIRROR_PROGRESS":
      return { ...state, progressBarProgress: action.payload }
    case "SET_PROGRESS":
      return {
        ...state,
        quizProgress: action.payload,
        progressBarProgress: action.payload,
      }
    case "INCREMENT_TOTAL_PROGRESS":
      const newProgress = state.currentTotalProgress + 1
      return { ...state, currentTotalProgress: newProgress }
    case "DECREMENT_TOTAL_PROGRESS":
      const newTotalProgress =
        state.currentTotalProgress > 1
          ? state.currentTotalProgress - 1
          : state.currentTotalProgress
      return { ...state, currentTotalProgress: newTotalProgress }
    case "SET_GLOBAL_PROGRESS":
      return { ...state, currentTotalProgress: action.payload }
    case "SET_TOTAL_QUESTIONS":
      return { ...state, totalQuestions: action.payload }
    case "SET_SHOW_BACK_BUTTON":
      return { ...state, showBackBtn: action.payload }
    case "SET_QUIZ_MOUNTED":
      return { ...state, quizMounted: action.payload }
    case "SET_EMAIL_CAPTURE":
      return { ...state, email_capture: action.payload }
    default:
      return state
  }
}

export const dynamicSectionLengthReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "DYNAMICALLY_SET_SECTION_LENGTH":
      return {
        ...state,
        [action.payload.section + "length"]: action.payload.length,
      }
    default:
      return state
  }
}

export const userReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_NAME":
      return { ...state, name: action.payload }
    case "SET_POST_PARTUM":
      return { ...state, postPartum: action.payload }
    default:
      return state
  }
}

export const sectionLengthReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_SECTION_LENGTH":
      return { ...state, sectionLength: action.payload }
    default:
      return state
  }
}

export const sectionReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_CURRENT_SECTION":
      return { ...state, currentSection: action.payload }
    default:
      return state
  }
}

export const genderReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_USER_GENDER":
      return { ...state, gender: action.payload }
    default:
      return state
  }
}

export const ageReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_USER_AGE":
      return { ...state, age: action.payload }
    default:
      return state
  }
}

export const interstitialReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "START_INTERSTITIAL":
      return { ...state, interstitial: true }
    case "END_INTERSTITIAL":
      return { ...state, interstitial: false }
    default:
      return state
  }
}

export const tokenReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_USER_TOKEN":
      return { ...state, token: action.payload }
    default:
      return state
  }
}

export const globalIdReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_GLOBAL_ID":
      return { ...state, currentGlobalId: action.payload }
    default:
      return state
  }
}

export const responseCompleteReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_RESPONSE_COMPLETE":
      return { ...state, responseComplete: true }
    default:
      return state
  }
}

export const resultsResponseCompleteReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case "RES_COMPLETE":
      return { ...state, resultsResponseComplete: true }
    default:
      return state
  }
}

export const directionReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "TOGGLE_MOVING_FORWARD":
      return { ...state, movingForward: action.payload }
    default:
      return state
  }
}

export const globalUnmountReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "TRIGGER_GLOBAL_UNMOUNT":
      return { ...state, globalUnmount: action.payload }
    default:
      return state
  }
}

export const revealProgressReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "REVEAL_OR_HIDE_PROGRESS":
      return { ...state, hideProgressForName: action.payload }
    case "TOGGLE_NAME_GREETING":
      return { ...state, showNameGreeting: action.payload }
    default:
      return state
  }
}

export const setSubscriptionIdReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_SUBSCRIPTION_ID":
      return { ...state, subscription_id: action.subscription_id }
    default:
      return state
  }
}

export const setCustomerIdReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_CUSTOMER_ID":
      return { ...state, customer_id: action.payload }
    default:
      return state
  }
}

export const setIsMhmdReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_IS_MHMD":
      return { ...state, isMhmd: action.payload }
    default:
      return state
  }
}

export const setMhmdStateReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_MHMD_STATE":
      return { ...state, mhmdState: action.payload }
    default:
      return state
  }
}

export const setMhmdOptedReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_MHMD_OPTED":
      return { ...state, mhmdOpted: action.payload }
    default:
      return state
  }
}

export const setHeaderVariantReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_HEADER_VARIANT":
      return { ...state, isIntroMode: action.payload }
    default:
      return state
  }
}
